import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { WebRouletteStatus } from 'app/core/model/web-roulette-status';
import { Roulette } from 'app/public/model/roulette.model';
import { StripePaymentsService } from 'app/public/services/stripe-payments.service';
import { SubscriptionService } from 'app/public/services/subscription.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { StripeService } from 'ngx-stripe';
import { catchError } from 'rxjs/operators';
import { FieldDialogComponent } from '../field-dialog/field-dialog.component';

@Component({
  selector: 'app-roulette-general-details',
  templateUrl: './roulette-general-details.component.html',
  styleUrls: ['./roulette-general-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouletteGeneralDetailsComponent implements OnInit {
  @Input()
  roulette: Roulette;

  @Input() form: NgForm;
  @ViewChild(FieldDialogComponent) fieldDialog: FieldDialogComponent;

  expireDaysOptions = [7, 14, 30, 45, 60, 90, 120];

  public get rouletteDetails() { return this.roulette?.GeneralDetails };

  constructor(private messageService: AdvMessageService,
    private localizationService: LocalizationService, private subscriptionService: SubscriptionService,
    private cdr: ChangeDetectorRef, private stripePaymentsService: StripePaymentsService
    , private stripeService: StripeService) { }

  ngOnInit(): void {
  }
  get isAvailable() {
    return this.roulette && (this.roulette.GeneralDetails.Status == WebRouletteStatus.purched ||
      this.roulette.GeneralDetails.Status == WebRouletteStatus.purchedFreePackage ||
      this.roulette.GeneralDetails.Status == WebRouletteStatus.purchedNotLimitPackage);
  }
  changeAutoRenewal(event) {
    switch (this.roulette.GeneralDetails.Status) {
      case WebRouletteStatus.expired:
      case WebRouletteStatus.notPurched:
      case WebRouletteStatus.purchedNotLimitPackage:
      case WebRouletteStatus.purchedFreePackage:
      case WebRouletteStatus.spinsLimitForFreePackage:
        //do nothing
        break;
      default:
        this.changeRenewalPackage(event.checked);

    }
  }
  changeRenewalPackage(renewal: boolean) {
    const confirmMsg = renewal ? 'ROULETTE.CHANGE_RENEWAL_MSG' : 'ROULETTE.CHANGE_NOT_RENEWAL_MSG';

    this.messageService.showConfirmation(this.localizationService.Translate("ROULETTE.CHANGE_RENEWAL_TITLE"),
      this.localizationService.Translate(confirmMsg), (ok) => {
        this.buyRenewalPackage(renewal);
      }
      ,
      (cancel) => {
        this.cancelAutoRenewalChange(renewal);
      });
  }

  buyRenewalPackage(renewal: boolean) {
    if (!renewal) {
      this.doChangeRenewalPackage(renewal);
    } else {
      this.stripePaymentsService.businessHasMethodPayment()
        .pipe(catchError((error) => {
          this.cancelAutoRenewalChange(renewal);
          throw error;
        }))
        .subscribe((hasMethodPayment: Boolean) => {
          if (hasMethodPayment) {
            this.doChangeRenewalPackage(renewal);
          } else {
            this.subscriptionService.createStripeSessionForAutoRenewal(this.roulette.GeneralDetails.Id, `${window.location.origin}/webplatform/payment-success`, `${window.location.origin}/webplatform/payment-failed`)
              .pipe(catchError((error) => {
                this.cancelAutoRenewalChange(renewal);
                throw error;
              }))
              .subscribe((response: any) => {
                this.stripeService.redirectToCheckout({
                  sessionId: response.SessionId,
                }).subscribe(data => {
                });
              });
          }
        });
    }
  }

  cancelAutoRenewalChange(renewal: boolean) {
    this.roulette.GeneralDetails.AutoRenewalPackage = !renewal;
    this.cdr.markForCheck();
  }
  doChangeRenewalPackage(renewal: boolean) {
    const successMsg = renewal ? 'ROULETTE.CHANGE_RENEWAL_SUCCESS' : 'ROULETTE.CHANGE_NOT_RENEWAL_SUCCESS';
    this.subscriptionService.changeRenewalPackage(this.roulette.GeneralDetails.Id, renewal)
      .pipe(catchError((error) => {
        this.cancelAutoRenewalChange(renewal);
        throw error;
      })).subscribe(() =>
        this.messageService.successMessage(this.localizationService.Translate(successMsg)
        ));
  }
  
}
